import React, { useRef } from "react";
import { Divider, Typography, useTheme } from "@mui/material";
import "react-medium-image-zoom/dist/styles.css";
import "../JaldiLab.css";
import { generateOrderedList, paraStyle, referenceHtml, referenceStyle, referenceTootKit } from "./ChapterList";
import { DashedBorderStyle } from "./ChapterList";
import RoadMapImg from "../../../assets/SvgIcons/RoadMapImg.png";
import RoadMapImg2 from "../../../assets/SvgIcons/RoadMapImg2.png";
import RoadMapImg3 from "../../../assets/SvgIcons/RoadMapImg3.png";
import RoadMapImg4 from "../../../assets/SvgIcons/RoadMapImg4.png";
import RoadMapImg5 from "../../../assets/SvgIcons/RoadMapImg5.png";
import RoadMapImg6 from "../../../assets/SvgIcons/RoadMapImg6.png";
import { h1style, h2style, h3style, sectionStyle } from "./ChapterList";
import CaptionWithBorders1 from "../../../components/ChapterImage/Image";
import { FigureDesc10, FigureDesc11, FigureDesc6, FigureDesc7, FigureDesc8, FigureDesc9 } from "../../../utils/tmp/ImageDescription/MappingUsersID";

const MappingUserPage = ({ goToSection }) => {
  const theme = useTheme();

  const referencesRef = useRef(null);

  const handleScrollToReferences = () => {
    if (referencesRef.current) {
      referencesRef.current.scrollIntoView({
        block: "center",
        inline: "nearest",
        behavior: "smooth",
      });
    }
  };

  // const reference = (_data, number) => {
  //   return referenceTootKit(_data, number, handleScrollToReferences);
  // };

  // const referenceData = [

  //   {
  //     content: "The Judicial Staff, for the purposes of this Handbook, includes Administrative Staff only. The Handbook does not provide specifications for any of the service staff or any other service providers who may be directly employed by the Court or employed through an external agency. "
  //   }
  // ]

  const accusedPersonArray = [
    "Provision for designated entrances for the Accused Persons ensuring direct movement into the Court Complex, avoiding unessential interaction with other stakeholders.",
    "Adequate, trained, and sensitised security at the entrance to support the diverse user groups using the Court Complex.",
    "Provision for designated, secure, and accessible parking for diverse user groups such as Persons with Disabilities, pregnant women, etc.",
    "Implementation of appropriate spatial planning and crowd management strategies at the entrance of the Court building, to facilitate the ability of the designated personnel to address various security situations effectively.",
    "Provision for accessible, well-ventilated and humane lockups for all genders.",
    "Provision for designated waiting areas for the Accused to wait their turn for Court appearances.",
    "Provision for adequate designated seating within the Courtrooms for the Accused Persons, which are accessible for diverse user groups.",
    "Provision for adequate, well-maintained and accessible washrooms and drinking water facilities within the lock-up. ",
    "Provision for a meeting room for Accused Persons to interact with their Advocates and family members. ",
  ];

  const advocatesArray = [
    "Provision for designated entrances for the Advocates to enter the Court Complex.",
    "Provision of efficient security equipment and personnel to ensure efficient and organised movement to the designated parking.",
    "Provision for accessible amenities such as ATMs, signages, tactile pavers with ramps, medical centres, ramps, bank branches, etc.",
    "Implementation of appropriate spatial planning and crowd management strategies at the entrance of the Court building, to facilitate the ability of the designated personnel to address various security situations effectively. ",
    "Provision for adequate space and implementation of crowd management strategies at the filing counter, to ensure filing is undertaken in a systematic and organised manner. ",
    "Provision for an adequate number of well-maintained facilities and amenities such as an Advocates’ association room/lounge, meeting area,  waiting areas, washrooms, and cafeteria.",
    "Provision for adequate facilities for reprographic services and case files. ",
    "Provision for functional and well-maintained washrooms for diverse user groups such as Advocates of all genders, pregnant women, Persons with Disabilities, etc. ",
    "Provision for adequate space in the administrative section to ensure administrative functions are undertaken in a systematic and organised manner.",
    "Facilitating access to potable drinking water, and display boards, information kiosks and auditory announcements providing information regarding the listed cases, in the waiting area outside the Courtroom.",
    "Strategic planning to ensure adequate designated seating, ease of movement for diverse user groups, spatial provision for interpreters, equipment for online hearings and better acoustics within the Courtroom.",
    "Facilitating access to requisite legal journals, online materials and facilities for online hearings. ",
    "Provision for well-maintained and accessible canteens for Advocates. ",
  ];

  const judicialOfficersArray = [
    "Provision for designated entrance for the Judges to enter the Court Complex.",
    "Provision of efficient security equipment and personnel to ensure a secure pathway to the Judges’ entrance. ",
    "Provision for designated, secure, and accessible parking for diverse user groups such as Persons with Disabilities, pregnant women, etc.",
    "Implementation of appropriate spatial planning and crowd management strategies at the entrance of the Court building, to facilitate the ability of designated personnel to address various security situations effectively.",
    "Adequate strategic planning for the layout of the Judges’ chamber, availability of adequate storage facilities, ergonomic and comfortable seating, and functional and well-maintained toilets for diverse user groups.",
    "Adequate strategic planning within the Courtroom to ensure that the dais is accessible to diverse user groups, crowd management and spatial provision for interpreters, equipment for online hearings, and better acoustics.",
    "Facilitating access to requisite legal journals, online materials and facilities to meaningfully interact with peers regarding legal proceedings and the day-to-day workings of the Court.",
    "Provision for relaxation areas for Judicial Officers, especially in such instances where the Court Complex is located at a distance from the main city.",
    "Provision for adequate facilities for video conferencing",
  ];

  const judicialStaffArray = [
    <>Provision for designated entrance for the Judicial Staff
    {/* {reference(referenceData[0], 1)}  */}
    to enter the Court Complex.</>,
    "Provision of efficient security equipment and personnel allocated to secure the pathway to the designated entrance for the judicial staff. ",
    "Provision for designated, secure and accessible parking for diverse user groups such as Persons with Disabilities, pregnant women,  etc. ",
    "Implementation of appropriate spatial planning and crowd management strategies at the entrance of the Court building, to facilitate the ability of the designated security personnel to address various security situations effectively.",
    "Adequate strategic planning for the layout of the office chambers, availability of adequate storage facilities, ergonomic and comfortable seating, and functional and well-maintained toilets for diverse user groups.",
    "Adequate strategic planning for the layout of the multi-people office spaces to ensure that the related functions are adjacent to each other, the office spaces are designed keeping in mind the functions being carried out within, placement of electronic equipment, etc., and that they are well-ventilated.",
    "Provision of facilities for reprographic services and case files, digitization of files, etc. ",
    "Provision of adequate space in the administrative section to ensure administrative functions are undertaken in a systematic and organised manner.",
    "Provision for segregated pathways for uninterrupted movement of judicial staff in the spaces within the Court Complex.",
    "Provision for an adequate number of functional and well-maintained washrooms for diverse user groups such as staff of all genders, older persons, Persons with Disabilities, etc.",
    "Provision for an adequate number of facilities such as an accessible lounge, libraries, etc.",
    "Adequate strategic planning within the Courtroom to ensure that the dais is accessible to diverse user groups, adequate space is provided on the dais for the staff as well as storage of relevant files, space for unrestricted movement around all parts of the Courtroom and placement of equipment for online hearings, and better acoustics.",
    "Adequate strategic planning within the Courtroom to ensure that the Judges’ corridor and chambers are accessible from the Courtroom for diverse user groups.",
    "Facilitating amenities such as canteens and sanitary provisions that are accessible and well-maintained.",
  ];

  const litigantsArray = [
    "Provision of signage at the entrance indicating the segregated paths into different spaces and the layout of the Court Complex.",
    "Engaging an adequate number of trained and sensitised security personnel to support the diverse user groups using the Court Complex.",
    "Provision for accessible amenities such as information desks, signages, tactile pavers with ramps, medical centres, ramps, bank branches, etc.",
    "Provision for adequate number of parking spaces for litigants, and designated accessible parking spaces for diverse user groups such as Persons with Disabilities, pregnant women, etc.",
    "Implementation of appropriate spatial planning and crowd management strategies at the entrance of the Court building, to facilitate the ability of the designated personnel to address various security situations effectively.",
    "Provision for adequate number of facilities which are well-maintained such as waiting area, lounge, washrooms and cafeteria",
    "Provision for adequate space and implementation of crowd management strategies at the filing counter, to ensure filing is undertaken in a systematic and organised manner.",
    "Provision for adequate  facilities for reprographic services  and case files.",
    "Provision for adequate space in the administrative section to ensure filing is undertaken in a systematic and organised manner.",
    "Provision for adequate number of functional and well-maintained washrooms for diverse user groups such as litigants/witnesses/experts of all genders, children, Persons with Disabilities, etc.",
    "Facilitating access to potable drinking water for litigants, and display boards, information kiosks and auditory announcements providing information regarding the listed cases. ",
    "Adequate strategic planning to ensure adequate designated seating, ease of movement for diverse user groups, spatial provision for interpreters, equipment for online hearings, and better acoustics within the Courtroom.",
    "Provision for well-maintained and accessible canteen for litigants.",
  ];

  const vulnerableWitnessArray = [
    "Provision and planning for designated entrances for the Vulnerable Witness ensuring direct movement into the Court Complex without interaction with other stakeholders.",
    "Engaging an adequate number of trained and sensitised security to support the diverse user groups using the Court Complex.",
    "Provision for adequate designated, secure, and accessible parking spaces for diverse user groups such as Persons with Disabilities, pregnant women, etc.",
    "Provision for the VWDC to not be directly accessible from the public entrance of the Court building, or secured paths from the entrance to the VWDC waiting area to ensure that the Vulnerable Witness does not cross paths with the Accused.",
    "Provision and planning for accessible waiting areas meeting the needs of diverse Vulnerable Witnesses such as child victims, teenagers, women, elderly persons, Persons with Disabilities, etc. ",
    "Provision for the necessary technology and comfortable seating within the videolinkage/deposition room. ",
    "Facilitating accessible Courtrooms with provision for testimonial aids such as screens, single visibility mirrors, curtains, live links, image or voice-altering devices, translators, interpreters, experts or other special educators within the Courtroom.",
    "Provision for accessible, well-maintained washrooms and drinking water facilities within the VWDC. ",
    "Provision for a well-maintained pantry to ensure that the Vulnerable Witness does not have to interact with other stakeholders within the Court Complex.",
    "Provision for a separate provision for counselling/psychologist room in the VWDC.",
    "Provision and planning for green spaces within or in close proximity to the VWDC to ensure a calm and comfortable environment.",
  ];

  return (
    <div>
      <Typography>
        <h1 style={h1style} id="designFramework">
          PART B - PRINCIPLES-BASED DESIGN FRAMEWORK
        </h1>
        <p style={paraStyle}>
          A symptom of the deep-rooted problem of the Indian judiciary is the
          lack of user-centricity. Our Courts, as with most other public places,
          continue to be designed for able-bodied male users and are not
          responsive to the needs of other diverse groups who interact with
          these spaces. The gap in thinking about and building Court Complexes
          for multiple categories manifests in different ways, and primarily
          affects the largest set of users - the litigants and the general
          public.
        </p>
        <p style={paraStyle}>
          Court Complexes have been known to be notoriously hard to navigate for
          all who are unfamiliar with the system; the absence of comprehensive
          wayfinding and information signage at most Courts, including signage
          in local languages or adequate visual representation, makes this even
          harder. Accessibility remains a significant challenge in our Courts,
          with efforts to address it often falling short. For example, external
          ramps lack overhead cover, and tactile pavers are frequently
          obstructed by furniture or other barriers, hindering movement.
        </p>
        <p style={paraStyle}>
          Even for internal stakeholders such as Judges and staff, Court
          Complexes remain uncomfortable workspaces, lacking thoughtful and
          well-articulated consideration of their needs. Audits conducted by the
          JALDI team across various jurisdictions have highlighted issues such
          as poorly lit and ventilated administrative offices, chambers, and
          Courtrooms, often situated near inadequately maintained toilets or
          drains, further compromising the health and well-being of daily users.
        </p>
        <p style={paraStyle}>
          The journey of each stakeholder through the Court Complex has
          therefore been mapped to highlight and understand concerns and
          requirements, and formulate guidelines for a user-centric design.
        </p>
        <h2 id="courtComplexHeading" style={h2style}>
          <span style={{ fontSize: "24px" }}> 1. </span>
          UNDERSTANDING THE JOURNEY OF ALL USERS THROUGH A TYPICAL COURT COMPLEX
        </h2>
        <p style={paraStyle}>
          Within the Court Complex, there are various categories of users who
          interact with different persons and use different spaces and
          facilities. The following illustrations depict the journey of
          <span
            style={{
              padding: "0px 5px",
              color: "#DC002D",
            }}
          >
            six categories of users
          </span>
          as they move through the Court Complex to avail the services provided
          or conduct their work.
        </p>
        <p style={paraStyle}>
          This section aims to highlight and summarise their needs and issues
          that may be faced by them in this journey. These issues and needs
          reflect the absence of certain core values which are essential for
          designing a Court Complex. These core values are represented as
          principles and guidelines in{" "}
          <span
            onClick={() => goToSection("designPrinciples", "Principle")}
            style={sectionStyle}
          >
            PART B, Section 2{" "}
          </span>
          of the Handbook.
        </p>
        <h3 id="accusedPersonHeading" style={h3style}>
          <span style={{ fontSize: "20px" }}>1.1. </span>
          Needs of the Accused Persons
        </h3>
        <CaptionWithBorders1
          image={[RoadMapImg]}
          isZoom={true}
          caption={
            "Figure 6: Journey of the Accused Persons through the Court Complex"
          }
          zoomImgStyle={{ height: "500px", objectFit: "contain" }}
          imageDescription={FigureDesc6}
        />

        {generateOrderedList(accusedPersonArray)}
        <DashedBorderStyle />

        <h3 id="advocatesHeading" style={h3style}>
          <span style={{ fontSize: "20px" }}> 1.2. </span>
          Needs of the Advocates
        </h3>

        <CaptionWithBorders1
          image={[RoadMapImg2]}
          isZoom={true}
          caption={
            "Figure 7: Journey of the Advocates through the Court Complex"
          }
          zoomImgStyle={{ height: "600px", objectFit: "contain" }}
          imageDescription={FigureDesc7}
        />

        {generateOrderedList(advocatesArray)}
        <DashedBorderStyle />

        <h3 id="judicialOfficersHeading" style={h3style}>
          <span style={{ fontSize: "20px" }}> 1.3. </span>
          Needs of the Judicial Officers
        </h3>

        <CaptionWithBorders1
          image={[RoadMapImg3]}
          isZoom={true}
          caption={
            "Figure 8: Journey of the Judicial Officers through the Court Complex"
          }
          zoomImgStyle={{ height: "600px", objectFit: "contain" }}
          imageDescription={FigureDesc8}
        />

        {generateOrderedList(judicialOfficersArray)}
        <DashedBorderStyle />

        <h3 id="judicialStaffHeading" style={h3style}>
          <span style={{ fontSize: "20px" }}> 1.4. </span>
          Needs of the Judicial Staff
        </h3>

        <p style={paraStyle}>
          The Judicial Staff, for the purposes of this Handbook, includes
          Administrative Staff only. The Handbook does not provide
          specifications for any of the service staff or any other service
          providers who may be directly employed by the Court or employed
          through an external agency.
        </p>

        <CaptionWithBorders1
          image={[RoadMapImg4]}
          isZoom={true}
          caption={
            "Figure 9: Journey of the Judicial Staff through the Court Complex"
          }
          zoomImgStyle={{ height: "600px", objectFit: "contain" }}
          imageDescription={FigureDesc9}
        />

        {generateOrderedList(judicialStaffArray)}
        <DashedBorderStyle />

        <h3 id="litigantsHeading" style={h3style}>
          <span style={{ fontSize: "20px" }}> 1.5. </span>
          Needs of the Litigants
        </h3>

        <CaptionWithBorders1
          image={[RoadMapImg5]}
          isZoom={true}
          caption={
            "Figure 10: Journey of the Litigants through the Court Complex"
          }
          zoomImgStyle={{ height: "600px", objectFit: "contain" }}
          imageDescription={FigureDesc10}
        />

        {generateOrderedList(litigantsArray)}
        <DashedBorderStyle />
        <h3 id="vulnerableWitnessesHeading" style={h3style}>
          <span style={{ fontSize: "20px" }}> 1.6. </span>
          Needs of the Vulnerable Witnesses
        </h3>

        <CaptionWithBorders1
          image={[RoadMapImg6]}
          isZoom={true}
          caption={
            "Figure 11: Journey of the Vulnerable Witnesses through the Court Complex"
          }
          zoomImgStyle={{ height: "600px", objectFit: "contain" }}
          imageDescription={FigureDesc11}
        />

        {generateOrderedList(vulnerableWitnessArray)}

        {/* <h2 ref={referencesRef} id="mappinRef" style={referenceStyle}>
          References
          <Divider />
        </h2> */}
        {/* {referenceHtml(referenceData)} */}
      </Typography>
    </div>
  );
};

export default MappingUserPage;
